(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pleesd-brand-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pleesd-brand-products')) {
    customElements.define('pleesd-brand-products', class extends HTMLElement {
      connectedCallback() {
        if (this.loaded) return;
        this.controller = new AbortController();
        this.loadProducts();
      }
      disconnectedCallback() { this.controller?.abort(); }
      async loadProducts() {
        const controller = this.controller;
        const timeout = setTimeout(() => controller.abort(), 12000);
        try {
          const url = new URL(this.dataset.url, window.location.origin);
          if (url.origin !== window.location.origin) return;
          url.searchParams.set('view', 'pleesd-brand-feed');
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) throw new Error('Unable to load products');
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const feed = document.querySelector('[data-pleesd-brand-feed]');
          if (!feed || !this.isConnected) return;
          const products = [...feed.querySelectorAll('[data-product-id]')].filter(card => card.dataset.productId !== this.dataset.productId && card.dataset.vendor === this.dataset.vendor).slice(0, 4);
          this.querySelector('[data-brand-products]').replaceChildren(...products);
          this.querySelector('.pe-brand-products-fallback').hidden = true;
          if (products.length === 0) this.closest('.pe-brand-products-shell')?.setAttribute('hidden', '');
          this.loaded = true;
        } catch (error) {
          this.loaded = false;
        } finally { clearTimeout(timeout); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pleesd-brands"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pleesd-brands')) {customElements.define('pleesd-brands',class extends HTMLElement{connectedCallback(){if(this.initialized)return;this.initialized=true;const input=this.querySelector('input');if(!input)return;const rows=[...this.querySelectorAll('[data-brand]')];const normalize=value=>value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ł/g,'l').replace(/Ł/g,'L').toLocaleLowerCase();input.addEventListener('input',()=>{const value=normalize(input.value.trim());let count=0;rows.forEach(row=>{row.hidden=!normalize(row.dataset.brand).includes(value);if(!row.hidden)count++;});this.querySelector('[data-empty]').hidden=count>0;});}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pleesd-inspired"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pleesd-looks'))customElements.define('pleesd-looks',class extends HTMLElement{
 connectedCallback(){if(this.initialized)return;this.initialized=true;this.querySelectorAll('details').forEach(details=>{details.addEventListener('keydown',e=>{if(e.key==='Escape'&&details.open){details.open=false;details.querySelector('summary')?.focus();}});});}
});

  } catch(e) { console.error(e); }
})();
})();
